/**
 * Chip — toggleable filter element with optional leading icon.
 * Default: 1 px line border, ink-2 text. Active: ink fill, paper text. Used in
 * Toolband for facet filters.
 * Source: .agents/design/project/artboard-radical-vozidla.jsx:36-42
 */

import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode;
  /** Leading icon node (typically `<Icon size={12} />`). */
  icon?: ReactNode;
  /** Visual + ARIA pressed state. */
  active?: boolean;
}

export function Chip({
  children,
  icon,
  active = false,
  className = '',
  type = 'button',
  disabled,
  ...rest
}: ChipProps) {
  const base =
    'inline-flex items-center gap-1.5 border px-2.5 py-1.5 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-line disabled:hover:text-ink-3';
  const state = active
    ? 'border-ink bg-ink text-paper'
    : 'border-line bg-paper text-ink-2 hover:border-ink hover:text-ink';
  return (
    <button
      {...rest}
      type={type}
      aria-pressed={active}
      disabled={disabled}
      className={`${base} ${state} ${className}`}
    >
      {icon}
      {children}
    </button>
  );
}
